import { RelativeTaxRateStrategy } from '@mews-distributor/common';
import { LocalizedPercent } from '@mews/framework';

interface RelativeTaxRateProps {
    strategy: RelativeTaxRateStrategy;
}

export const RelativeTaxRate: React.FC<RelativeTaxRateProps> = ({ strategy }) => (
    <LocalizedPercent percent={strategy.value} />
);
